const regex = {
  home: new RegExp('/pro/?#?/?$'),
  research: new RegExp('/(public|pro)/(research|contests|members/posts|fund_letters|ideas)'),
  members: new RegExp('/(public|pro)/(members/)?(profiles|rankings)'),
  media: new RegExp('/public/(podcast_episodes|videos)'),
  capIntro: new RegExp('/pro/cap-intro/(funds|allocators|accredited_investors)'),
  careers: new RegExp('/pro/(job_postings|compensation)'),
  partnerOffers: new RegExp('/pro/partner-offers'),
  secFilings: new RegExp('/pro/sec_filings/(insider_trades)'),
  communityChats: new RegExp('/pro/(sector-chats|quick_positions)')
};

export const isActiveTab = tabToTest => {
  const pattern = /\/([^/]+)\/?$/;
  const path = tabToTest.match(pattern);

  if (path) {
    return window.location.pathname.includes(path[1]);
  }
};

export const getActiveSection = () => {
  if (window.location && window.location.pathname) {
    for (var key in regex) {
      if (regex[key].test(window.location.pathname)) return key;
    }
  }
  return false;
};
